import { reject } from "core-js/fn/promise";
import { clientePedido } from "../../apiClient/index";

const moduloResumenDeCuenta = {
  namespaced: true,
  state: {
    filtrosResumenDeCuenta: {
      cuenta: undefined,
      from: undefined,
      to: undefined,
      periodo: "RESUMENDECUENTA_periodo_meses_1",
      tipo_filtro: "RESUMENDECUENTA_periodo",
      ordenar: "",
      checkPeriodo: true,
      checkRango: false,
      clientes: undefined,
      clienteSeleccionado: undefined,
      clientesOption: undefined
    },
    paginadorDocumentos: {
      page: 1,
      nro_pages: 1,
      pageSize: 10,
    },
  },
  actions: {
    getDocumentos(context, payload) {
      return new Promise((resolve) => {
        clientePedido
          .get("api/Cuentas/GetResumen", { params: payload })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },
    getCuentas(context, idUsuario) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetCuentasCorrientes", {
            params: { idUsuario: idUsuario },
          })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },
    getCancelaciones(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetCancelacionesDocumentos", { params: payload })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },

    setFiltrosResumenDeCuenta(context, payload) {
      context.commit("setFiltrosResumenDeCuenta", payload);
    },
    setPaginadorDocumentos(context, payload) {
      context.commit("setPaginadorDocumentos", payload);
    },
    getRecibo(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetRecibo", {
            params: { idRecibo: payload.idRecibo },
          })
          .then((response) => {
            resolve(response.data.Datos);
          })
          .catch(() => reject());
      });
    },
    descargarFactura(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/DescargarFactura", {
            params: payload,
            responseType: "arraybuffer",
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    exportarExcel(_, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("/api/cuentas/ExportExcelResumen", { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
  },
  mutations: {
    setFiltrosResumenDeCuenta(state, payload) {
      state.filtrosResumenDeCuenta = payload;
    },
    setPaginadorDocumentos(state, payload) {
      state.paginadorDocumentos = payload;
    },
  },
};

export default moduloResumenDeCuenta;
